import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import {
    chain,
    DispatchCompleteLoadOrder,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import loadOrderLinesDetails from "@tKgpco/Store/Data/OrderHistoryDetail/Handlers/LoadOrderLinesDetails";

type HandlerType = ApiHandlerDiscreteParameter<
    { orderNumber: string; expand?: ("orderLines" | "shipments" | "vmidetails")[]; customerNumber?: string },
    GetOrderApiParameter,
    OrderModel
>;

export const PopulateApiParameterExtension: HandlerType = props => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
        customerNumber: props.parameter.customerNumber,
        expand: props.parameter.expand ?? ["orderLines", "shipments"],
    };
    props.dispatch({
        type: "Custom/Orders/ResetLoadOrderDetailsLine",
    });
};

export const DispatchCompleteLoadOrderCustom: HandlerType = props => {
    const order = props.apiResult;
    props.dispatch({
        type: "Data/Orders/CompleteLoadOrder",
        model: props.apiResult,
    });

    if (order?.orderLines?.length) {
        const totalLines = order.orderLines.length;
        const pageSize = 100; // each page has 100 lines
        const totalPages = Math.ceil(totalLines / pageSize);

        for (let page = 1; page <= totalPages; page++) {
            props.dispatch(
                loadOrderLinesDetails({
                    orderNumber: order.erpOrderNumber || order.webOrderNumber,
                    pageNumber: String(page),
                    currentDateTime: new Date().toString(),
                }),
            );
        }
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension);
replaceInChain(chain, DispatchCompleteLoadOrder, DispatchCompleteLoadOrderCustom);
